



































import { computed, defineComponent, onMounted, WritableComputedRef } from "@vue/composition-api"
import { useGetters, useActions } from "vuex-composition-helpers"

export default defineComponent({
    name: "ExchangeFilter",
    setup: () => {
        const {
            getLabels,
            getUniqueAdmissions,
            getSelectedFilterYear,
            getSelectedFilterStudy,
            getExchangeYears
        } = useGetters([
            'getLabels',
            'getUniqueAdmissions',
            'getSelectedFilterYear',
            'getSelectedFilterStudy',
            'getExchangeYears'
        ])

        const {
            setSelectedFilterYear,
            setSelectedFilterStudy
        } = useActions([
            'setSelectedFilterYear',
            'setSelectedFilterStudy'
        ])

        const selectedYear: WritableComputedRef<string> = computed({
            get(): string {
                return getSelectedFilterYear.value
            },
            set(value: string): void {
                setSelectedFilterYear(value)
            }
        })
        const selectedStudy: WritableComputedRef<string> = computed({
            get(): string {
                return getSelectedFilterStudy.value
            },
            set(value: string): void {
                setSelectedFilterStudy(value)
            }
        })

        return {
            getUniqueAdmissions,
            getExchangeYears,
            selectedStudy,
            selectedYear,
            getLabels
        }
    }
})
